
import { cn } from '../../../Utils/component'
import type { ButtonProps, ButtonSizeProp } from './types'

export const buttonClassName = ({
  color,
  invert,
  size,
}: ButtonProps): string =>
  cn([
    'disabled:opacity-80 disabled:cursor-not-allowed transition-colors',
    'transition-colors duration-300 ease-in-out rounded-md border-[0.5px]',
    getButtonColor(color, invert),
    getButtonSize(size),
  ])
export function getButtonColor(color?: string, invert?: boolean) {
  if (invert) {
    switch (color) {
      case 'secondary':
        return 'text-white hover:text-secondary bg-secondary hover:bg-white border-secondary hover:border-secondary'
      case 'apply':
        return 'text-night bg-very-light-blue hover:text-very-light-blue hover:bg-night border-night hover:border-night disabled:border-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-gray-300'
      case 'primary':
        return 'text-white hover:text-primary bg-primary hover:bg-white border-primary'
      default:
        return `text-white hover:text-${color} bg-${color} hover:bg-white border-${color} hover:border-${color}`
    }
  }
  switch (color) {
    case 'secondary':
      return 'text-secondary hover:text-white bg-white hover:bg-secondary border-secondary hover:border-white'
    case 'apply':
      return 'text-very-light-blue hover:text-night bg-night hover:bg-very-light-blue border-very-light-blue hover:border-night disabled:cursor-not-allowed disabled:bg-gray-300'
    case 'primary':
      return 'text-primary hover:text-white bg-white hover:bg-primary border-primary hover:border-white border-primary/30'
    case 'white':
      return 'text-night bg-white'
    default:
      return ` text-[${color}] hover:text-white bg-white hover:bg-[${color}] border-[${color}] hover:border-white`
  }
}
export function getButtonSize(size?: ButtonSizeProp) {
  switch (size) {
    case 'small':
      return `px-3 py-1.5 text-xs`
    case 'medium':
      return `px-4 py-2 text-sm font-medium`
    case 'lg':
      return `lg:text-lg text-md font-medium px-5 py-[6px]`
    case 'xl':
      return `px-8 py-2 font-medium lg:text-xl text-md`
    default:
      return `px-6 py-2 tracking-wide`
  }
}
